import {BOT_CONV_MESSAGE_TYPE} from '../../../../helpers/consts/common-consts';
import ReactMarkdown from "react-markdown";
import HtmlMessage, {isHtmlContent, extractHtml} from "../html-message";
import {citationNumber, linkCitations} from "../../../../helpers/utils/citation-utils";
import CitationRef, {sourcesOf} from "../citation/citation-ref";

// relative time https://day.js.org/docs/en/plugin/relative-time
export default function TextMessage({senderType, message, metadata, chatBotSetting, onInvokeAction, onCitationClick, disabled}) {
  // A TEXT payload wrapped in <html>…</html> is rendered as (sanitized) HTML
  // instead of markdown. Everything else takes the markdown path unchanged.
  if (isHtmlContent(message)) {
    return (
      <HtmlMessage
        html={extractHtml(message)}
        onInvokeAction={onInvokeAction}
        disabled={disabled}
      />
    );
  }

  // Convert plain URLs/emails to markdown links so ReactMarkdown renders them as anchors
  const autoLink = (text) => {
    if (!text || typeof text !== 'string') return '';
    const urlRegex = /(https?:\/\/[^\s]+)|(www\.[^\s]+)|(mailto:[^\s]+)|([A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,})/gi;
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    return text.replace(urlRegex, (match) => {
      let href = match;
      // Email: add mailto: if plain email
      if (emailRegex.test(href)) {
        href = `mailto:${href}`;
      } else {
        // Add scheme for www. links (but not for mailto:)
        if (!/^https?:\/\//i.test(href) && !/^mailto:/i.test(href)) {
          href = `https://${href}`;
        }
      }
      return `[${match}](${href})`;
    });
  };

  // [n] in the answer is the nth source listed under it (citation-utils).
  // Linked before autoLink, which leaves markdown links as they are.
  const sources = sourcesOf(metadata);
  const enhancedMessage = autoLink(linkCitations(message, sources.length));

  return (
    <ReactMarkdown 
    className={`prose chat-text-bubble ${senderType === BOT_CONV_MESSAGE_TYPE ? 'chat-bot-bubble' : 'chat-user-bubble'}`}
    style={senderType === BOT_CONV_MESSAGE_TYPE ? undefined : { backgroundColor: chatBotSetting?.headerBackgroundColor, color: chatBotSetting?.headerTextColor }}
    components={{
      a: ({node, children, ...props}) => {
        const number = citationNumber(props.href);
        if (number !== null) {
          return <CitationRef number={number} source={sources[number - 1]} onCitationClick={onCitationClick} />;
        }
        return (
          <a
            {...props}
            target="_blank"
            rel="noopener noreferrer"
          >
            {children}
          </a>
        );
      },
    }}
    >
      {enhancedMessage}
    </ReactMarkdown>
  );
}

